import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import JobTitle from './title/JobTitle';
import JobDetails from './job_details/JobDetails';
import JobAnnouncement from './announcement/JobAnnouncement';

const JobHeader = (props) => {
  const {
    jobData,
    client,
    latestAnnouncementMessage,
    jobBackend,
    refresh,
    setRefresh,
    showJobTypePill,
    loomJob,
    onEditJob,
    onRegenerateJob,
  } = props;
  return (
    <Stack gap={1}>
      <JobTitle
        jobData={jobData}
        client={client}
        jobBackend={jobBackend}
      />
      <JobDetails
        jobData={jobData}
        client={client}
        jobBackend={jobBackend}
        refresh={refresh}
        setRefresh={setRefresh}
        showJobTypePill={showJobTypePill}
        loomJob={loomJob}
        onEditJob={onEditJob}
        onRegenerateJob={onRegenerateJob}
      />
      <JobAnnouncement
        latestAnnouncementMessage={latestAnnouncementMessage}
        jobBackend={jobBackend}
      />
    </Stack>
  );
};
JobHeader.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object,
  latestAnnouncementMessage: PropTypes.object,
  jobBackend: PropTypes.object.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
  showJobTypePill: PropTypes.bool,
  loomJob: PropTypes.bool,
  onEditJob: PropTypes.func,
  onRegenerateJob: PropTypes.func,
};

export default React.memo(JobHeader);
